import { render, staticRenderFns } from "./CoScrollMarker.vue?vue&type=template&id=32ff9550&"
import script from "./CoScrollMarker.vue?vue&type=script&lang=ts&"
export * from "./CoScrollMarker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports